import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Supprime le token lorsque le composant est monté
    localStorage.removeItem('token');
    
    // Redirige vers la page de login
    navigate('/');
  }, [navigate]); // Ajout de navigate comme dépendance

  return <p>Déconnexion...</p>;
};

export default Logout;
